<template>
  <MultiStepView :isEdit="true" :initialData="existingReportData" />
</template>

<script>
import MultiStepView from './GroupedReport/MultiStepView.vue';

export default {
  components: { MultiStepView },
  data() {
    return {
      existingReportData: {
        token: this.$route.params.token,
        name: this.$route.params.name,
        events: this.$route.params.eventIds,
        users: this.$route.params.userIds,
      },
    };
  },
};
</script>